import { trackEvent, trackPageview } from "@garantidos/utils/tracking"

const pageview = (hashedCpf) => {
  const ga4 = {
    customPath:
      "credito/cgimovel/quitado/contratacao/env-proposta/validacao-seguranca-sms",
    hashedCpf,
    implementationTeam: "cgi:v01"
  }

  const ga = {
    label: "IT:NL:NCC:CGI:ValidacaoSegurancaSMS",
    hashedCpf
  }
  const segment = "Simulation Page Viewed"

  trackPageview({ ga, ga4, segment })
}

const back = (hashedCpf) => {
  const ga4 = {
    customPath:
      "credito/cgimovel/quitado/contratacao/env-proposta/validacao-seguranca-sms",
    hashedCpf,
    implementationTeam: "cgi:v01",
    detail: "validacao-seguranca-sms-voltar",
    eventName: "click"
  }

  trackEvent({ ga4 })
}

const advance = () => {
  trackEvent({ segment: "Sms Sent" })
}

const backHome = (hashedCpf) => {
  const ga4 = {
    customPath:
      "credito/cgimovel/quitado/contratacao/env-proposta/validacao-seguranca-sms",
    hashedCpf,
    implementationTeam: "cgi:v01",
    detail: "validacao-seguranca-sms-voltar-inicio",
    eventName: "click"
  }
  trackEvent({ ga4 })
}

const advanceGA4 = (hashedCpf) => {
  const ga4 = {
    customPath:
      "credito/cgimovel/quitado/contratacao/env-proposta/validacao-seguranca-sms",
    hashedCpf,
    implementationTeam: "cgi:v01",
    detail: "validacao-seguranca-sms-avancar",
    eventName: "click"
  }

  trackEvent({ ga4 })
}

const alert = (hashedCpf, error) => {
  const ga4 = {
    customPath:
      "credito/cgimovel/quitado/contratacao/env-proposta/validacao-seguranca-sms",
    hashedCpf,
    implementationTeam: "cgi:v01",
    detail: error.message
      ?.toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replaceAll(/ /g, "-")
      .replaceAll(/!/g, ""),
    eventName: "alert"
  }

  trackEvent({ ga4 })
}

export { pageview, back, alert, backHome, advance, advanceGA4 }
